/// <amd-module name="Environments/Landing/Actions/EnvironmentsActions" />
import { ActionsHubBase, Action } from "Environments/Flux/ActionCreatorBase";
import { IEnvironmentsResult } from "Environments/Client/EnvironmentContracts";

export class EnvironmentsActions extends ActionsHubBase {

    public static getKey(): string {
        return "environments-actions";
    }

    public initialize(instanceId?: string) {
        this._setEnvironments = new Action<IEnvironmentsResult>();
        this._appendEnvironments = new Action<IEnvironmentsResult>();
    }

    public get setEnvironments(): Action<IEnvironmentsResult> {
        return this._setEnvironments;
    }

    public get appendEnvironments(): Action<IEnvironmentsResult> {
        return this._appendEnvironments;
    }

    private _setEnvironments: Action<IEnvironmentsResult>;
    private _appendEnvironments: Action<IEnvironmentsResult>;
}
